module.exports = __webpack_public_path__ + "img/boxtal.b4d45b4c.jpg";